import {
  Box,
  Popper,
  Theme,
  makeStyles,
  createStyles,
} from '@material-ui/core';

import React, { useState } from 'react';

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    popper: {
      zIndex: 10000,
    },
    root: {
      color: 'white',
      padding: '1em',
      borderRadius: 3,
      backgroundColor: '#222222EE',
      fontSize: 14,
      width: 370,
      maxWidth: '75vw',
      '& a': {
        display: 'block',
        color: 'inherit',
        textDecoration: 'none',
      },
      '& a:hover span': {
        color: 'white',
      },
      '& span': {
        color: theme.palette.primary.light,
        textDecoration: 'underline',
      },
    },
  })
);

type Props = {
  children: any;
  title: string;
  right?: boolean;
};

export const Tooltip: React.FC<Props> = ({ children, title, right }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setOpen(true);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setAnchorEl(null);
    setOpen(false);
  };

  return (
    <>
      <a
        href="#"
        onClick={(e) => {
          handleClick(e);
          e.stopPropagation();
          e.preventDefault();
        }}
        style={{ cursor: 'help', float: right ? 'right' : 'none' }}
      >
        {children}
      </a>
      <Popper anchorEl={anchorEl} open={open} className={classes.popper}>
        <Box className={classes.root}>
          <a href="#" onClick={handleClose}>
            {title}{' '}
            <div style={{ fontWeight: 'bold', textAlign: 'right' }}>
              Schließen
            </div>
          </a>
        </Box>
      </Popper>
    </>
  );
};
